export const PODCASTS_PARTNER_URL = 'https://www.lacledeschamps.fr/';
